import { render, staticRenderFns } from "./PythagoreanSquareResultView.vue?vue&type=template&id=dc08313e&scoped=true&"
import script from "./PythagoreanSquareResultView.vue?vue&type=script&lang=ts&"
export * from "./PythagoreanSquareResultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc08313e",
  null
  
)

export default component.exports